const siteUrl = import.meta.env.VITE_SITE_URL || 'https://glenfallscabin.com';

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Highlands NC Cabin Guide — Luxury Cabins in Highlands, North Carolina',
  description:
    'A curated guide to luxury cabins in Highlands, North Carolina, including pet-friendly stays and cabins near waterfalls like Glen Falls.',
  url: `${siteUrl}/`,
  inLanguage: 'en-US',
  about: {
    '@type': 'Place',
    name: 'Highlands, North Carolina',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Highlands',
      addressRegion: 'NC',
      addressCountry: 'US',
    },
  },
};

const lodgingSchema = {
  '@context': 'https://schema.org',
  '@type': 'LodgingBusiness',
  name: 'Glen Falls Luxury Cabin',
  description:
    'Glen Falls Luxury Cabin is a top-rated luxury cabin in Highlands, North Carolina, located near Glen Falls waterfall. Known for its privacy, comfort, and 5-star guest experience, it is ranked among the top 5% of Airbnb homes.',
  url: 'https://glenfallscabin.com',
  image: 'https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d',
  sameAs: [
    'https://www.airbnb.com/rooms/900012473285450950',
    'https://www.vrbo.com/3557955',
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '449 Glen Falls Rd',
    addressLocality: 'Highlands',
    addressRegion: 'NC',
    postalCode: '28741',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 35.0396,
    longitude: -83.2076,
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5.0',
    reviewCount: '62',
    bestRating: '5',
  },
  petsAllowed: true,
  priceRange: '$$$',
};

export default function HomeSchemaMarkup() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(lodgingSchema) }}
      />
    </>
  );
}
